import type { WorkObjectTypeIcon } from "../../../../entities/work-object-type/model/use-work-object-types";
import { TablerIconPicker } from "@/shared/ui/icon-picker/tabler-icon-picker";

type WorkObjectTypeIconPickerProps = {
  compact?: boolean;
  disabled?: boolean;
  onValueChange: (value: WorkObjectTypeIcon) => void;
  value: WorkObjectTypeIcon;
};

export function WorkObjectTypeIconPicker({ compact = false, disabled, onValueChange, value }: WorkObjectTypeIconPickerProps) {
  return (
    <TablerIconPicker
      compact={compact}
      context="workObjectType"
      disabled={disabled}
      onValueChange={onValueChange}
      value={value}
    />
  );
}
